export const AUTH_CONSTANTS = {
  RATE_LIMIT_COOLDOWN_MS: 60000,
  RATE_LIMIT_COOLDOWN_SECONDS: 60,
  MIN_PASSWORD_LENGTH: 8,
} as const;

export const AUTH_MESSAGES = {
  RATE_LIMIT: 'Too many attempts. Please wait a minute before trying again.',
  INVALID_CREDENTIALS: 'Invalid email or password.',
  SIGNUP_FAILED: 'Unable to create account. Try a different email or sign in.',
  TIMEOUT: 'The server is taking too long to respond. Please try again.',
  GENERIC_ERROR: 'Authentication failed. Please try again.',
  SIGNUP_SUCCESS: 'Please check your email to verify your account.',
} as const;

export const PASSWORD_REQUIREMENTS = {
  MIN_LENGTH: 8,
  REQUIRE_UPPERCASE: true,
  REQUIRE_LOWERCASE: true,
  REQUIRE_NUMBER: true,
  REQUIRE_SPECIAL: true,
  SPECIAL_CHARS: '!@#$%^&*(),.?":{}|<>',
} as const;
